import { render } from "./BlogSecurityAudit.vue?vue&type=template&id=5c580935"
import script from "./BlogSecurityAudit.vue?vue&type=script&lang=js"
export * from "./BlogSecurityAudit.vue?vue&type=script&lang=js"

import "./BlogSecurityAudit.vue?vue&type=style&index=0&id=5c580935&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__